export function createUnionShape(shapes) {
    if (shapes.length === 1) {
        return shapes[0];
    }
    function containsPoint(point) {
        return shapes.some((shape) => shape.containsPoint(point));
    }
    function* getRuns(outerIndex, rowIndex, depthRun, slab) {
        const runs = [];
        for (const shape of shapes) {
            for (const run of shape.getRuns(outerIndex, rowIndex, depthRun, slab)) {
                runs.push([run[0], run[1]]);
            }
        }
        if (!runs.length) {
            return;
        }
        runs.sort((a, b) => a[0] - b[0]);
        let [low, high] = runs[0];
        for (let index = 1; index < runs.length; index++) {
            const [nextLow, nextHigh] = runs[index];
            if (nextLow <= high + 1) {
                high = Math.max(high, nextHigh);
                continue;
            }
            yield [low, high];
            low = nextLow;
            high = nextHigh;
        }
        yield [low, high];
    }
    return {
        containsPoint,
        getRuns,
        getRequiredThickness: () => shapes.reduce((deepest, shape) => {
            const required = shape.getRequiredThickness();
            return required > deepest ? required : deepest;
        }, 0),
    };
}
